<template>
	<div>
		<TriggerEditorHeader :title="title" />
		<ToolTriggerFormDataProvider :workflow="editWorkflow" />
	</div>
</template>

<script>
import { editWorkflow } from '@/store/modules/selectedWorkflow/getters';
import { mapGettersShorthand } from '@/store/utils/mappers';
import WorkflowToolService from '@/utils/workflow-tool-service';
import ToolTriggerFormDataProvider from './ToolTriggerFormDataProvider.vue';
import TriggerEditorHeader from './TriggerEditorHeader.vue';

export default {
	name: 'ToolTriggerEditor',
	computed: {
		...mapGettersShorthand({ editWorkflow }),
		title() {
			return WorkflowToolService.getToolWorkflowFullTitle(this.editWorkflow);
		},
	},
	components: { TriggerEditorHeader, ToolTriggerFormDataProvider },
};
</script>

<style lang="scss" scoped></style>
